var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3828 4.80469L6.25781 8.92969C6.11719 9.07031 5.85938 9.07031 5.71875 8.92969C5.57812 8.78906 5.57812 8.53125 5.71875 8.39062L9.21094 4.89844H0.375C0.164062 4.89844 0 4.73438 0 4.52344C0 4.33594 0.164062 4.14844 0.375 4.14844H9.21094L5.71875 0.679688C5.57812 0.539062 5.57812 0.28125 5.71875 0.140625C5.85938 0 6.11719 0 6.25781 0.140625L10.3828 4.26562C10.5234 4.40625 10.5234 4.66406 10.3828 4.80469Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.cb1327731b41f2b491902058b3a651e9.svg";
export { ForwardRef as ReactComponent };